<script lang="ts" setup>
// import { Bell } from 'lucide-vue-next';
import { Menu } from 'lucide-vue-next';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { isLogin } from '@/utils/auth';
import { UserMenu } from '@/components/user-menu';
import useAppStore from '@/stores/modules/app';

const isLoginState = isLogin();
const appStore = useAppStore();
const route = useRoute();

// 只在 settings 布局下显示汉堡按钮
const isSettingsLayout = computed(() => route.path.startsWith('/settings'));
</script>

<template>
  <header class="page-header fixed top-0 z-40 h-16 w-full bg-[var(--bgColor-muted)] text-[14px] border-b border-border">
    <div class="mx-5 h-full flex-y-center justify-between">
      <div class="flex-y-center gap-x-3">
        <div class="h-9 w-9 shrink-0">
          <RouterLink to="/" class="block size-full">
            <img src="@/assets/logo.svg" alt="LOGO" class="block size-full object-contain object-left">
          </RouterLink>
        </div>

        <!-- 移动端汉堡按钮，仅在 settings 页面显示 -->
        <button
          v-if="isLoginState && isSettingsLayout"
          class="md:hidden flex items-center justify-center size-8 rounded-md text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
          aria-label="打开导航菜单"
          @click="appStore.toggleSidebar"
        >
          <Menu class="size-5" />
        </button>
      </div>

      <div class="shrink-0" v-if="isLoginState">
        <div class="flex-y-center gap-x-8 text-[14px]">
          <!-- <RouterLink to="/settings/notice/message`" target="_blank" class="relative block size-5 focus-visible:outline-unset">
            <Bell class="size-full" />
            <div class="absolute -right-0.75 -top-0.75 h-1.5 w-1.5 rounded-[50%] bg-[#E24E40]"></div>
          </RouterLink> -->

          <UserMenu />
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
</style>
